<template>
  <div id="media-add-new-update-dialog" class="custom-modal">
    <div class="modal-body">
      <HolaconLottie  v-if="loading == 'updateScreenLoading' && form == null" key="create-loading" />
      <el-row v-else key="content-loading">
        <el-row :gutter="10">
          <el-col :span="24">
            

            <el-button-group class="w-100 switch-btn-container">

              <el-button :type="form.type == 0 ? 'primary' : ''" size="mini" round @click="changeType(0)">{{ $t("contentManagement.eventAlbum.gallery.mediaComponent.img") }}</el-button>

              <el-button :type="form.type == 1 ? 'primary' : ''" size="mini" round @click="changeType(1)">{{ $t("contentManagement.eventAlbum.gallery.mediaComponent.youtubeVideo") }}</el-button>

            </el-button-group>

          </el-col>
        </el-row>
        <el-row class="mt-3" :gutter="10">
          <el-col :span="24">
            <div class="registerform-input-container">
                <div class="custom-label">
                  <label>{{ $t("contentManagement.eventAlbum.gallery.mediaComponent.title") }}</label>
                  <el-tooltip placement="top">
                    <div slot="content" class="custom-tooltip-content"><span>{{ $t("contentManagement.eventAlbum.gallery.mediaComponent.titleMsg") }}</span></div>
                    <i class="el-icon-info"></i>
                  </el-tooltip>
                </div>
              <el-input v-model="form.title" :class="$inputError('title', validationErrors)"></el-input>
              <span class="error">{{ $errorMessage('title', validationErrors) }}</span>
            </div>
          </el-col>
          <transition-group name="el-fade-in">
            <el-col :span="24" v-show="form.type == 0" class="mt-3" :key="'type-0'">
              <div class="registerform-input-container">
                <div class="custom-label">
                  <label>{{ $t("contentManagement.eventAlbum.gallery.mediaComponent.img") }}</label>
                  <el-tooltip placement="top">
                    <div slot="content" class="custom-tooltip-content"><span>{{ $t("contentManagement.eventAlbum.gallery.mediaComponent.imgMsg") }}</span></div>
                    <i v-if="logoPercent > 0" class="el-icon-loading"></i>
                    <i class="el-icon-info" v-else></i>
                  </el-tooltip>
                </div>
                <div class="mage-maker drag" :style="{ background: form.url ? `url(${form.url})` : 'none', 'border-radius': '5px' }">
                  <el-upload :class="$inputError('url', validationErrors)" :style="{ opacity: !!form.url ? '0' : '1' }" :on-progress="mediaProgress" class="avatar-uploader" :action="axios.defaults.baseURL + 'event/uploadImage?uploadType=eventAlbum&language=' + $i18n.locale" :headers="{ Authorization: axios.defaults.headers['Authorization'] }" :show-file-list="false" drag :on-success="mediaSuccess">
                    <i class="el-icon-upload"></i>
                    <div class="el-upload__text" v-html="$t('generic.uploadText')"></div>
                  </el-upload>
                </div>
                <span class="error">{{ $errorMessage('url', validationErrors) }}</span>
              </div>
            </el-col>
            <el-col :span="24" v-show="form.type == 1" class="mt-3" :key="'type-1'">
              <div class="registerform-input-container">
                <div class="custom-label">
                      <label>{{ $t("contentManagement.eventAlbum.gallery.mediaComponent.youtubeVideoUrl") }}</label>
                      <el-tooltip placement="top">
                        <div slot="content" class="custom-tooltip-content"><span>{{ $t("contentManagement.eventAlbum.gallery.mediaComponent.youtubeVideoUrlMsg") }}</span></div>
                        <i v-if="logoPercent > 0" class="el-icon-loading"></i>
                        <i class="el-icon-info" v-else></i>
                      </el-tooltip>
                    </div>
                <el-input v-model.lazy="form.url" placeholder="https://youtu.be/YjhrligRTbE" @clear="form.url = null" clearable :class="$inputError('url', validationErrors)"></el-input>
                <span class="error">{{ $errorMessage('url', validationErrors) }}</span>
              </div>
            </el-col>
            <el-col :span="24" v-show="form.type == 1 && form.url != null" class="mt-3" :key="'type-2'">
              <div class="registerform-input-container">
                <div class="custom-label">
                  <label>{{ $t("contentManagement.eventAlbum.gallery.mediaComponent.preview") }}</label>
                  <!-- <el-tooltip content="Content" placement="bottom">
                    <i class="el-icon-info"></i>
                  </el-tooltip> -->
                </div>
                <iframe width="100%" height="315" :src="'https://www.youtube.com/embed/' + youtubeUrl" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
              </div>
            </el-col>
          </transition-group>
        </el-row>
  
        <el-row :gutter="10">
          <el-col class="mt-2" :span="24">
            <div class="custom-section-container">
              <div class="section-header" @click="settingsDock = !settingsDock">
                <div class="section-title">
                  <div class="section-head">
                    <label>{{ $t("contentManagement.eventAlbum.gallery.mediaComponent.settings") }}</label>
                    <!-- <el-tooltip content="Content" placement="bottom">
                          <i class="el-icon-info"></i>
                        </el-tooltip> -->
                  </div>
                  <span>{{ $t("contentManagement.eventAlbum.gallery.mediaComponent.settingsMsg") }}</span>
                </div>
                <div class="section-accordion">
                  <i class="fa" :class="settingsDock ? 'fa-angle-up' : 'fa-angle-down'"></i>
                </div>
              </div>
              <transition name="el-zoom-in-top">
                <div class="section-wrapper" v-show="settingsDock">
                  <div class="custom-set-container" :class="form.isActive ? 'sactive' : 'spassive'">
                    <div class="custom-set-inner">
                      <i class="fa" :class="form.isActive ? 'fa-eye' : 'fa-eye-slash'"></i>
                      <div class="custom-set-info">
                        <label>{{ $t("contentManagement.eventAlbum.gallery.mediaComponent.view") }}
                          <!-- <el-tooltip content="Content" placement="bottom">
                            <i class="el-icon-info"></i>
                          </el-tooltip> -->
                        </label>
                        <span>{{ $t("contentManagement.eventAlbum.gallery.mediaComponent.viewMsg") }}</span>
                      </div>
                    </div>
                    <div class="custom-set-actions fend">
                      <el-switch v-model="form.isActive"></el-switch>
                    </div>
                  </div>
                </div>
              </transition>
            </div>
          </el-col>
        </el-row>
      </el-row>
    </div>
    <div class="modal-footer" slot="footer" v-if="loading != 'updateScreenLoading' && form != null">
      <div class="left-buttons">
        <el-button @click="$emit('closeDialog');">{{ $t("contentManagement.eventAlbum.gallery.mediaComponent.close") }}</el-button>
        <template v-if="form.id != null">
          <el-popconfirm @confirm="deleteItem" :confirmButtonText="$t('event.variables.yes')" :cancelButtonText="$t('event.buttons.cancel')" icon="el-icon-info" iconColor="red" :title="$t('event.textbox.toDelete')">
          <el-button slot="reference" type="danger" icon="fas fa-trash" > {{ $t("contentManagement.eventAlbum.gallery.mediaComponent.delete") }}</el-button>
        </el-popconfirm>
        </template>
     
      </div>
      <div class="right-buttons">
        <el-button type="primary" :loading="loading == 'saveLoading'" :disabled="loading == 'saveLoading'" @click="save">{{ $t("contentManagement.eventAlbum.gallery.mediaComponent.save") }}</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
export default {
  props: ['id', 'typeMedia'],
  data() {
    return {
      activeTab:0,
      settingsDock: false,
      rate: null,
      form: null,
      iconClasses: ['icon-angry', 'icon-sad', 'icon-grin'],
      logoPercent: 0,
      axios,
      loading: false,
      timeout: null,
      youtubeUrl: 'YjhrligRTbE',
      validationErrors: [],
    };
  },
  methods: {
    changeType(type) {
      this.form.type = type;
      this.form.url = null;
    },
    async save() {
      this.loading = 'saveLoading';
      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        var res = await this.$store.dispatch('addUpdateAlbum', this.form);
        this.validationErrors = res.data.validationErrors;
        if (!res.data.alert.hasError) {
          this.form = res.data.data.item;
          await this.$store.dispatch('getEventAlbum');
        }
        this.loading = false;
      }, 500);
    },
    async deleteItem() {
      if (this.typeMedia == 'album') {
        await this.$store.dispatch('deleteAlbum', this.form.id);
        this.$emit('closeDialog');
      }
    },
    mediaProgress(event) {
      this.mediaPercent = event.percent;
    },
    mediaSuccess(response) {
      this.logoPercent = 0;
      if (response.alert.hasError) {
        this.$message.error(response.alert.message);
      } else {
        this.$message.success(response.alert.message);
        this.form.url = response.data.item.url;
      }
    },
  },
  watch: {
    'form.url': function() {
      if (this.form.type == 1 && this.form.url != null) {
        if (this.form.url.indexOf('v=') != -1) {
          this.form.url = "https://youtu.be/" + this.getParameterByName('v', this.form.url);
        } else {
          var indexL = this.form.url.lastIndexOf('/');
          this.youtubeUrl = this.form.url.slice(indexL + 1);
        }
      }
    },
  },
  async created() {
    this.loading = 'updateScreenLoading';
    if (this.timeout != null) clearTimeout(this.timeout);

    if (this.id != undefined && this.id != null) {
      this.timeout = setTimeout(async () => {
        var res = await this.$store.dispatch('getAlbum', this.id);
        if (!res.data.alert.hasError) {
          this.form = res.data.data.item;
        } else {
          this.$emit('closeDialog');
        }
        this.loading = false;
      }, 500);
    } else {
      this.timeout = setTimeout(() => {
        this.form = {
          id: null,
          type: 0,
          title: null,
          url: null,
          isActive: false,
        };
        this.loading = false;
      }, 500);
    }
  },
};

// function getParameterByName(name, url = window.location.href) {
//     name = name.replace(/[\[\]]/g, '\\$&');
//     var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
//         results = regex.exec(url);
//     if (!results) return null;
//     if (!results[2]) return '';
//     return decodeURIComponent(results[2].replace(/\+/g, ' '));
// }

</script>

<style lang="less">
.registerform-input-container {
  .tag-container {
    gap: 1rem;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
  .badge-list {
    display: flex;
    flex-direction: row;
    gap: 1rem;
    .badger {
      border-radius: 8px;
      background-color: #f3f3f3;
      height: 20px;
      padding: 10px;
    }
  }
  .title {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 0.5rem;
    label {
      font-weight: bold;
      color: black;
      margin-bottom: 0;
    }
    .title-container {
      display: flex;
      flex-direction: row;
      gap: 1rem;
      align-items: center;
    }
  }
  display: flex;
  flex-direction: column;
  .el-input-number {
    width: 100%;
  }
}
.mage-maker {
  width: 100%;
  position: relative;
  border: 1px dashed #ccc;
  height: 250px;
  background-size: contain !important;
  background-position: center center !important;
  border-radius: 5px;
  background-repeat: no-repeat !important;
  .avatar-uploader {
    opacity: 0;
    transition: all 1s;
    &:hover {
      opacity: 1 !important;
    }
    & > .el-upload {
      background-color: rgba(0, 0, 0, 0.5);
      width: 100%;
      height: 250px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}
.group-btn-container {
  display: flex;
  flex-direction: row;
  gap: 0.5rem;
  justify-content: flex-end;
  align-items: center;

  .el-button {
    padding: 4px;
    margin-left: 0;
  }
  i.el-icon-info {
    font-size: 24px;
  }
}
.model-base-small {
  min-width: 500px;
}
.switch-btn-container {
  display: flex;
  .el-button {
    flex-grow: 1;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/MediaAddUpdate.vue